import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    console.log("Modal Controller connected")
    this.modal = new bootstrap.Modal(this.element)

    // this.element.addEventListener('turbo:submit-end', (event) => {
    //   console.log(event);
    //   if (event.detail.success) {
    //       this.modal.hide();
    //   }
    // });
  }
  disconnect() {
    console.log("Modal Controller disconnected")
    this.modal.hide()
  }

  open() {
    if (!this.modal.isOpened) {
      this.modal.show()
      //this.modalTarget.style.display = 'block'
    }
    //Fire a custom event to update styles on the newly inserted element.
    // Create the event
    //var custon_event = new CustomEvent("element_inserted", { "detail": "A new element was inserted in the dom." });
    // Dispatch/Trigger/Fire the event
    //document.dispatchEvent(custon_event);

    //return event.preventDefault();
  }

  close(event) {
    if (event.detail.success) {
      this.modal.hide()
      // $('body').removeClass('modal-open');
      // $('.modal-backdrop').remove();
    }
  }
}
